import Vue from 'vue'
import { HTTP_DELETE, HTTP_GET, HTTP_POST, HTTP_PUT } from '../const';
import { LOAD_DEPOSITS_LIST, RESET_DEPOSITS } from "@/store/const/deposits";

export default {
  namespaced: true,
  state: {
    deposits: {
      list: [],
      pagination: {},
    },
  },
  getters: {
    deposits: state => state.deposits,
  },
  actions: {
    [LOAD_DEPOSITS_LIST]: async ({ dispatch }, { params }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_DEPOSITS_LIST,
        namespace: 'deposits',
        params,
      }, { root: true });
    },
  },
  mutations: {
    [LOAD_DEPOSITS_LIST]: (state, { data }) => {
      Vue.set(state.deposits, 'list', data.list);
      Vue.set(state.deposits, 'pagination', data.pagination);
    },
    [RESET_DEPOSITS]: (state) => {
      Vue.set(state, 'deposits', { pagination: {}, list: []});
    }
  },
};
